var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bell-ring_svg__clip0_8632_24071)",
    fill: "#FFC834"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.905 22.681c.118.129.257.237.41.32.146.077.296.144.45.2a1.51 1.51 0 001.16 0 1.688 1.688 0 00.71-2.59 1.76 1.76 0 00-1.68-.66 1 1 0 00-.24.08l-.2.12a2.889 2.889 0 00-.49.39 1.839 1.839 0 00-.4.65 1.736 1.736 0 00-.11.45c.033.391.168.767.39 1.09M5.755 17.641l.16-4.06a25.45 25.45 0 01.26-4.1 7.05 7.05 0 011.88-3.19 8.87 8.87 0 012.61-2.19 6.64 6.64 0 015.68 0 7.29 7.29 0 013.85 5c.8 2.94.45 6 .49 9l.75-.75c-2.69.11-5.37-.17-8.06-.14-1.42 0-2.83.17-4.25.18-1.42.01-2.74-.05-4.11-.16-1-.08-.95 1.42 0 1.5 1.37.11 2.74.17 4.11.16 1.37-.01 2.83-.17 4.25-.18 2.69 0 5.37.25 8.06.14a.76.76 0 00.75-.75c-.07-5.17.73-12.17-4.69-15.1a8.33 8.33 0 00-6.5-.63 10.85 10.85 0 00-5.64 5.1 10.2 10.2 0 00-.84 4.54l-.22 5.62a.75.75 0 001.5 0l-.04.01z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bell-ring_svg__clip0_8632_24071"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.295 1.991)",
    d: "M0 0h17.89v21.31H0z"
  })))));
}
export default SvgBellRing;